<template>
  <div style="margin: 0 -15px;">
    <vs-row vs-type="flex" vs-justify="flex-start">
      <vs-col v-if="type" vs-w="4">
        <vs-row class="tools" vs-type="flex" vs-align="center" style="width: auto; height: auto; margin: 0 -15px;">
          <vs-col vs-w="6">
            <div @click="_showBackgroundPopup">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-1.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Фон</h4>
              </vx-card>
            </div>
          </vs-col>
          <vs-col vs-w="6">
            <div @click="_showImgPopup">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-2.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Изображение</h4>
              </vx-card>
            </div>
          </vs-col>
          <vs-col vs-w="6">
            <div @click="_createText">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-3.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Текст</h4>
              </vx-card>
            </div>
          </vs-col>
          <vs-col vs-w="6">
            <div @click="_showVideoPopup">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-4.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Видео</h4>
              </vx-card>
            </div>
          </vs-col>
          <vs-col vs-w="6">
            <div @click="_createButton">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-5.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Кнопка</h4>
              </vx-card>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
      
      <vs-col :vs-w="type ? 4 : 8">
        
        <vs-alert :active.sync="isPopupSaving" color="success">
          <span>Сохранение елементов</span>
        </vs-alert>
        <vs-alert :active.sync="isPopupLoading">
          <span>Загрузка елементов</span>
        </vs-alert>

        <vs-row>
          <vs-col style="padding:0;">
            <div v-if="layers.length > 0" class="layout-block">
              <div v-for="(item, index) in layers" :key="index" @click="_selectLayer(item)" style="cursor: pointer">
                <vs-chip :color="currentObject && item._id === currentObject._id ? 'primary' : ''">
                  <vs-avatar icon-pack="feather" :icon="_typeOfLayer(item).icon"/>
                  <span>{{ _typeOfLayer(item).name }}</span>
                </vs-chip>
              </div>
            </div>
          </vs-col>
        </vs-row>
        
        <div ref="layer" class="layer"> 
          
          <vs-row class="layer-controls" vs-type="flex" vs-align="center">
            <ConstructorGridControls :type="type" v-if="!type"/>
            <div style="margin-left: auto;">
              <vs-row vs-type="flex" vs-align="center">
                <span style="display: flex; margin-right: 50px;"  v-if="!type">
                  <button class="layer-controls__btn"
                          @click="_upItem">
                    <i class="feather icon-chevron-up"></i>
                  </button>
                  <button class="layer-controls__btn" @click="_downItem">
                    <i class="feather icon-chevron-down"></i>
                  </button>
                </span>
                <button v-if="!type" class="layer-controls__btn" @click="_createCopy">
                  <i class="feather icon-copy"></i>
                </button>
                <button v-if="!type" class="layer-controls__btn"
                        :class="currentObject && !currentObject.draggable() ? 'layer-controls__btn_active' : ''"
                        @click="_freezeItem">
                  <i class="feather icon-lock"></i>
                </button>
                <button class="layer-controls__btn" @click="_destroyItem">
                  <i class="feather icon-trash"></i>
                </button>
              </vs-row>
            </div>
          </vs-row>
          <div id="layer-canvas"></div>
        </div>
        <vs-row commented-if="!type" commented-style="margin: 0 -15px;">
          <vs-col style="padding:0">
            <div class="layout-block" :style="type ? 'margin: 0' : '' ">
              <vs-tabs >
                <vs-tab label="Основное" icon-pack="feather" icon="icon-settings">
                  <div v-if="isCurrentImage" class="tab-content">
                    <vs-row>
                      <vs-col vs-w="6">
                        <div style="width: 100%; margin-bottom: 15px;">
                          <img :src="currentObject.attrs.src" style="width: 200px;">
                        </div>
                      </vs-col>

                      <vs-col vs-w="6">
                        <div style="margin-bottom: 15px;">
                          <label>Название картинки</label>
                          <vs-input v-model="currentImageName" />
                        </div>
                        <vs-button class="tools__btn" style="color: #fff !important;" color="primary" icon-pack="feather" icon="icon-image"
                                   @click="_changeImage">Заменить
                        </vs-button>
                      </vs-col>
                    </vs-row>
                  </div>
                  <div v-if="isCurrentText" class="tab-content">
                    <vs-row>
                      <vs-col vs-w="6">
                        <div style="width: 200px; margin-bottom: 15px;">
                          <label for="text-text">Текст</label>
                          <vs-textarea id="text-text"
                                       placeholder="Ваш текст"
                                       v-model="currentTextInput"/>
                        </div>
                      </vs-col>
                      <vs-col vs-w="6">
                        <div style="width: 200px; margin-bottom: 15px;">
                          <label for="text-font-size">Размер текста</label>
                          <vs-input-number id="text-font-size" v-model="currentTextSize"/>
                        </div>
                        <div style="width: 200px; margin-bottom: 15px;">
                          <label for="text-font">Шрифт</label>
                          <vs-select id="text-font" class="selectExample" v-model="currentTextFont">
                            <vs-select-item v-for="(font, index) in fonts"
                                            :key="index"
                                            :value="font"
                                            :text="font"/>
                          </vs-select>
                        </div>
                        <div>
                          <vs-row vs-type="flex" vs-justify="center" vs-align="center"
                                  style="width: 200px; margin-bottom: 20px;">
                            <button class="layer-controls__btn"
                                    :class="currentTextAlign === 'left' ? 'layer-controls__btn_active' : ''"
                                    @click="_alignText('left')">
                              <i class="feather icon-align-left"></i>
                            </button>
                            <button class="layer-controls__btn"
                                    :class="currentTextAlign === 'center' ? 'layer-controls__btn_active' : ''"
                                    @click="_alignText('center')">
                              <i class="feather icon-align-center"></i>
                            </button>
                            <button class="layer-controls__btn"
                                    :class="currentTextAlign === 'right' ? 'layer-controls__btn_active' : ''"
                                    @click="_alignText('right')">
                              <i class="feather icon-align-right"></i>
                            </button>
                          </vs-row>
                        </div>
                      </vs-col>
                    </vs-row>
                    <div style="margin-bottom: 15px;">
                      <label for="text-font">Цвет текста</label>
                      <vs-row vs-type="flex" vs-justify="flex-start">
                        <material-picker
                          v-model="currentTextFill"
                          style="height: 120px; margin-right: 10px;"
                        ></material-picker>
                        <compact-picker
                          v-model="currentTextFill"
                        ></compact-picker>
                      </vs-row>
                    </div>
                    <div style="margin-bottom: 15px;">
                      <label for="text-font">Цвет фона</label>
                      <vs-row vs-type="flex" vs-justify="flex-start">
                        <material-picker
                          v-model="currentTextBackground"
                          style="height: 120px; margin-right: 10px;"
                        ></material-picker>
                        <compact-picker
                          v-model="currentTextBackground"
                        ></compact-picker>
                      </vs-row>
                    </div>
                  </div>
                  <div v-else-if="isCurrentButton" class="tab-content">
                    <div style="width: 200px; margin-bottom: 15px;">
                      <label>Тип кнопки</label>
                      <vs-select class="selectExample" v-model="currentBtnType">
                        <vs-select-item v-for="(type, index) in btnTypes"
                                        :key="index"
                                        :value="type.type"
                                        :text="type.name"/>
                      </vs-select>
                    </div>

                    <div style="width: 200px; margin-bottom: 15px;">
                      <label>{{ btnTypes.find(item => item.type === currentBtnType).name }}</label>
                      <vs-input v-model="currentButtonValue"></vs-input>
                    </div>

                    <div style="width: 200px; margin-bottom: 15px;">
                      <label>Текст</label>
                      <vs-input v-model="currentButtonText"></vs-input>
                    </div>
                    <div style="width: 200px; margin-bottom: 15px;">
                      <label>Шрифт кнопки</label>
                      <vs-select class="selectExample" v-model="currentButtonFont">
                        <vs-select-item v-for="(font, index) in fonts"
                                        :key="index"
                                        :value="font"
                                        :text="font"/>
                      </vs-select>
                    </div>
                    <div style="width: 200px; margin-bottom: 15px;">
                      <label>Размер текста</label>
                      <vs-input-number v-model="currentButtonSize"/>
                    </div>
                    <div style="margin-bottom: 15px;">
                      <label>Цвет текста</label>
                      <vs-row vs-type="flex" vs-justify="flex-start">
                        <material-picker
                          v-model="currentButtonTextColor"
                          style="height: 120px; margin-right: 10px;"
                        ></material-picker>
                        <compact-picker
                          v-model="currentButtonTextColor"
                        ></compact-picker>
                      </vs-row>
                    </div>
                    <!-- <div style="width: 200px; margin-bottom: 15px;">
                      <label>Толщина бордера</label>
                      <vs-input-number v-model="currentButtonBorderWidth"/>
                    </div>
                    <div style="margin-bottom: 15px;">
                      <label>Цвет бордера</label>
                      <vs-row vs-type="flex" vs-justify="flex-start">
                        <material-picker
                          v-model="currentButtonBorderColor"
                          style="height: 120px; margin-right: 10px;"
                        ></material-picker>
                        <compact-picker
                          v-model="currentButtonBorderColor"
                        ></compact-picker>
                      </vs-row>
                    </div> -->
                    <div style="margin-bottom: 15px;">
                      <label>Цвет кнопки</label>
                      <vs-row vs-type="flex" vs-justify="flex-start">
                        <material-picker
                          v-model="currentButtonColor"
                          style="height: 120px; margin-right: 10px;"
                        ></material-picker>
                        <compact-picker
                          v-model="currentButtonColor"
                        ></compact-picker>
                      </vs-row>
                    </div>
                  </div>
                  <div v-if="isCurrentVideo" class="tab-content">
                    <div style="margin-bottom: 20px;">
                      <label>Url</label>
                      <vs-input v-model="currentObject.attrs.url" style="width: 100%;"></vs-input>
                    </div>
                    <iframe :src="`https://www.youtube.com/embed/${youtubeId}`" style="width: 100%; min-height:300px"></iframe>
                  </div>
                </vs-tab>
                <vs-tab label="Оформление" icon-pack="feather" icon="icon-aperture">
                </vs-tab>
                <vs-tab id="integrity_tab" label="Интеграция" icon-pack="feather" icon="icon-link-2">
                </vs-tab>
              </vs-tabs>
            </div>
          </vs-col> 
          
        </vs-row>
      </vs-col>


      <vs-col v-if="!type" vs-w="4">
        <vs-button @click="_saveStage" class="tools__btn" color="success" icon-pack="feather" icon="icon-save">Сохранить</vs-button>
        <vs-button class="tools__btn" color="primary" icon-pack="feather" icon="icon-image"
                   @click="_showBackgroundPopup">Загрузить фон</vs-button>
        <vs-row class="tools" vs-type="flex" vs-align="center" style="width: auto; height: auto; margin: 0 -15px;">
          <vs-col vs-w="6">
            <div @click="_showImgPopup">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-2.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Изображение</h4>
              </vx-card>
            </div>
          </vs-col>
          <vs-col vs-w="6">
            <div @click="_createText">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-3.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Текст</h4>
              </vx-card>
            </div>
          </vs-col>
          <vs-col vs-w="6">
            <div @click="_showVideoPopup">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-4.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Видео</h4>
              </vx-card>
            </div>
          </vs-col>
          <vs-col vs-w="6">
            <div @click="_createButton">
              <vx-card class="text-center cursor-pointer tools-card">
                <img :src="require('@/assets/images/pages/graphic-5.png')" alt="graphic" class="mx-auto mb-4">
                <h4 class="mb-2">Кнопка</h4>
              </vx-card>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col :vs-w="type ? 4 : 12">
        <div v-if="type">
          <vs-button class="tools__btn" color="success" icon-pack="feather" icon="icon-save">Сохранить</vs-button>
          <vs-button class="tools__btn" color="primary" icon-pack="feather" icon="icon-image"
                     @click="_showBackgroundPopup">Загрузить фон</vs-button>
          <vx-card title="Свойства" collapse-action style="margin-bottom: 20px;">
            <p class="mb-3">You can create collapsible content card by setting <code>collapse-action</code> prop to <code>true</code>. By default it is set to false.</p>
          </vx-card>
          <vx-card title="Интеграции" collapse-action>
            <p class="mb-3">You can create collapsible content card by setting <code>collapse-action</code> prop to <code>true</code>. By default it is set to false.</p>
          </vx-card>
        </div>
        
      </vs-col>
    </vs-row>

    <vs-popup class="holamundo" title="Выберите задний фон" :active.sync="isPopupBg">
      <div>
        <div>
          <div class="con-input-upload">
            <input type="file" multiple="multiple" @change="_onFileChange">
            <span class="text-input">Загрузить задний фон</span>
            <span class="input-progress" style="width:0%;"></span>
            <button disabled="disabled" type="button" title="Upload" class="btn-upload-all vs-upload--button-upload">
              <i translate="translate" class="material-icons notranslate">cloud_upload</i>
            </button>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup class="holamundo" title="Выберите изображение" :active.sync="isPopupImg">
      <div>
        <!-- <div>
          <div v-for="(img, index) in popupImages" :key="index" class="popup-card">
            <img :src="img" class="popup-card__img" @click="_uploadImage(img)">
          </div>
        </div> -->
        <div>
          <div class="con-input-upload">
            <input type="file" multiple="multiple" @change="_onFileChange">
            <span class="text-input">Загрузить изображение</span>
            <span class="input-progress" style="width:0%;"></span>
            <button disabled="disabled" type="button" title="Upload" class="btn-upload-all vs-upload--button-upload">
              <i translate="translate" class="material-icons notranslate">cloud_upload</i>
            </button>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup class="holamundo" title="Вставьте ссылку на видео с YouTube" :active.sync="isPopupVideo">
      <div>
        <label>Url</label>
        <vs-input v-model="currentVideoUrl" style="width: 100%; margin-bottom: 10px;"></vs-input>
        <div style="margin-bottom: 10px;" v-if="youtubeId">
          <iframe :src="`https://www.youtube.com/embed/${youtubeId}`" style="width: 100%; min-height:300px"></iframe>
        </div>
        <vs-button color="primary" style="width: 100%;" :disabled="currentVideoUrl.length === 0"
                   @click="_createVideo()">Загрузить видео</vs-button>
      </div>
    </vs-popup>
    
  </div>
</template>

<script>
  import canvasHelper from '@/helpers/canvas/canvasHelper.js'
  import canvasConstructor from '@/helpers/canvas/canvasConstructor.js'
  import canvasUpload from '@/helpers/canvas/canvasUpload.js'

  import API from 'API';
  import Konva from 'konva';
  import {Material, Compact} from 'vue-color';
  //import getYouTubeID from 'get-youtube-id';

  import ConstructorGridControls from '@components/constructor/ConstructorGridControls.vue'

  export default {
    components: {
      'material-picker': Material,
      'compact-picker': Compact,
      ConstructorGridControls
    },

    props: {
      type: {
        type: Boolean,
        required: false
      }
    },

    data() {
      return {
        images: [],
        texts: [],
        layers: [],
        fonts: ["'Roboto', sans-serif", "'Open Sans', sans-serif", "'Pacifico', cursive"],
        btnTypes: [
          {type: 'url', name: 'Url'},
          {type: 'call', name: 'Звонок'},
          {type: 'request', name: 'Заявка'},
          {type: 'payment', name: 'Оплата'},
          {type: 'webhook', name: 'Webhook'},
          ],
        currentBtnType: 'url',
        background: null,
        currentObject: null,
        currentText: null,
        currentImage: null,
        currentTextAlign: 'left',
        currentVideoUrl: '',
        layer: null,
        stage: null,
        transform: null,
        grid: null,
        isPopupBg: false,
        isPopupImg: false,
        isPopupVideo: false,
        isPopupSaving: false,
        isPopupLoading: false,
        popupBgImages: [
          'http://pngimg.com/uploads/envelope/envelope_PNG18376.png'
        ],
        popupImages: [
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4Q7pXt9y8r1J3npnxP6XgdmkooBSQaowMyv--cHlAzZvQqt17'
        ]
      }
    },

    computed: {
      youtubeId() {
        let string = this.currentObject && this.currentObject.attrs.url || this.currentVideoUrl;
        console.log('youtubeid', this.currentObject, this.currentVideoUrl)
        return string.split('?v=')[1]  && string.split('?v=')[1].split('&')[0];
      },
      switchGrid() {
        return this.$store.state.constructor.switchGrid;
      },
      gridSize() {
        return this.$store.state.constructor.gridSize;
      },
      currentTextInput: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].text()
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Text)[0].text(newVal)
          this.layer.draw();
        }
      },
      currentImageName: {
        get: function () {
          return this.currentObject.name()
        },
        set: function (newVal) {
          this.currentObject.name(newVal)
        }
      },
      currentTextSize: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fontSize()
        },
        set: function (newVal) {
          const text = this.currentObject.children.filter(item => item instanceof Konva.Text)[0]
          text.fontSize(newVal)
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].width(text.width())
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].height(text.height())
          this._attacheTransform(this.currentObject);
          this.layer.draw();
        }
      },
      currentTextFont: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fontFamily()
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fontFamily(newVal)
          this.layer.draw();
        }
      },
      currentTextFill: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fill()
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fill(newVal.hex);
          this.layer.draw();
        }
      },
      currentTextBackground: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].fill()
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].fill(newVal.hex);
          this.layer.draw();
        }
      },
      currentButtonValue: {
        get: function () {
          return this.currentObject.attrs.url;
        },
        set: function (newVal) {
          this.currentObject.attrs.url = newVal;
        }
      },
      currentButtonText: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].text();
        },
        set: function (newVal) {
          let text = this.currentObject.children.filter(item => item instanceof Konva.Text)[0];
          this.currentObject.children.filter(item => item instanceof Konva.Text)[0].text(newVal);
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].width(text.width());
          this._attacheTransform(this.currentObject);
          this.layer.draw();
        }
      },
      currentButtonFont: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fontFamily();
        },
        set: function (newVal) {
          let text = this.currentObject.children.filter(item => item instanceof Konva.Text)[0];
          this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fontFamily(newVal);
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].width(text.width());
          this._attacheTransform(this.currentObject);
          this.layer.draw();
        }
      },
      currentButtonTextColor: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fill();
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fill(newVal.hex);
          this.layer.draw();
        }
      },
      currentButtonSize: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fontSize();
        },
        set: function (newVal) {
          let text = this.currentObject.children.filter(item => item instanceof Konva.Text)[0];
          this.currentObject.children.filter(item => item instanceof Konva.Text)[0].fontSize(newVal);
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].width(text.width());
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].height(text.height());
          this._attacheTransform(this.currentObject);
          this.layer.draw();
        }
      },
      currentButtonBorderWidth: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].strokeWidth();
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].strokeWidth(newVal);
          this._attacheTransform(this.currentObject);
          this.layer.draw();
        }
      },
      currentButtonBorderColor: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].stroke();
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].stroke(newVal.hex);
          this.layer.draw();
        }
      },
      currentButtonColor: {
        get: function () {
          return this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].fill();
        },
        set: function (newVal) {
          this.currentObject.children.filter(item => item instanceof Konva.Rect)[0].fill(newVal.hex);
          this.layer.draw();
        }
      },
      isCurrentText() {
        if (this.currentObject && this.currentObject.attrs.type === 'text'){
          var tab = document.getElementById('integrity_tab');
          if (tab) console.log(tab.style="display:none;")
          return true
        }
        return false;
      },
      isCurrentButton() {
        if (this.currentObject && this.currentObject.attrs.type === 'button'){
          var tab = document.getElementById('integrity_tab');
          if (tab) console.log(tab.style="display:block;")
          return true
        }
        return false;
      },
      isCurrentVideo() {
        if (this.currentObject && this.currentObject.attrs.type === 'video'){
          
          var tab = document.getElementById('integrity_tab');
          if (tab) console.log(tab.style="display:none;")
          
          return true
        }
        return false;
      },
      isCurrentImage() {
        if (this.currentObject && this.currentObject.attrs.type === 'image'){
          var tab = document.getElementById('integrity_tab');
          if (tab) console.log(tab.style="display:none;")
          return true
        }
        return false;
      }
    },

    mounted() {
      this.isPopupLoading = true;
      setTimeout(() => {
        this._createCanvas();
        this._loadProjectItems();
        this.type && this._clearGrid()
      }, 500)
    },
    destroyed() {
      if (this.interval) clearInterval(this.interval)
    },
    watch: {
      switchGrid(val) {
        if (val) {
          this._createGrid();
        } else {
          this._clearGrid();
        }
      },

      gridSize() {
        this._createGrid();
      }
    },

    methods: {
      //===================================================================
      //========================= КОНСТРУКТОРЫ ============================
      //===================================================================
      _createCanvas() {
        canvasConstructor.createCanvas(this);
      },

      _saveStage() {
        canvasConstructor.saveStage(this);
      },

      _createGrid() {
        canvasConstructor.createGrid(this)
      },

      _createText() {
        canvasConstructor.createText(this)
      },

      _createVideo() {
        canvasUpload.uploadImage(this.youtubeId, '', this, 'video')
      },

      _createButton() {
        canvasConstructor.createButton(this)
      },

      _createCopy() {
        canvasConstructor.createCopy(this)
      },

      _changeImage() {
        this._destroyItem();
        this._showImgPopup();
      },

      _loadProjectItems() {

          let __DEFFERER = [];
          __DEFFERER.onload =command=>{
            
            if (command == 'First'){
              for ( let i in __DEFFERER){
                let callback = __DEFFERER[i];
                if (callback.isBackground){
                  let element = callback();
                  element.addEventListener('load', __DEFFERER.onload )
                  __DEFFERER.splice(i, 1);
                }
              }
              return;
            }
            if (__DEFFERER.length > 0) {
              __DEFFERER.pop()();
              __DEFFERER.onload()
            }else{
              setTimeout(()=>this.isPopupLoading = false,500)
            }

          }
          __DEFFERER.add =(method, args)=> {
              function f(){
                method(...(f.args))
              }
              f.args = args;
              __DEFFERER.push(f);
          }

          let onHaveBackground = res => {
            
              console.log('onHaveBackground ',res.data )
              let bg_id = res.data.bg && res.data.bg.id;
              let image_url;
              if (!bg_id){
                
                if (res.data.bg && res.data.bg.length > 0 && res.data.bg[res.data.bg.length-1])
                {
                  bg_id = res.data.bg[res.data.bg.length-1].id;
                  image_url = res.data.bg[res.data.bg.length-1].image_url;
                }else
                  throw 'NO BACKGROUND!'

              }else{
                image_url = res.data.bg.image_url;
              }

              let f =()=>(console.log("Create background", bg_id, image_url), canvasConstructor.createBackground(this, bg_id, image_url) )
              f.isBackground = true;
              __DEFFERER.push(f);


              setTimeout(
                () => API.projects.getProjectItems(bg_id)
                  .then( res => {

                  /*
                  * Загрузка проекта и его елементов
                  * 
                  */

                    let items = res.data.items;
                    console.log('Find items', items)
                    for (const item of items) {
                      if (item.type == 'text') {
                        
                        __DEFFERER.add( canvasConstructor.createText,  [this, item])

                      } else if (item.type == 'button') {
                        
                        __DEFFERER.add( canvasConstructor.createButton,  [this, item])

                      } else if (item.type == 'image') {

                        __DEFFERER.add( canvasUpload.uploadImage,  [item.image_url, '', this, null, item])

                      } else if (item.type == 'video') {
                        
                        __DEFFERER.add( canvasUpload.uploadImage,  [item.video_src, '', this, 'video', item])

                      }
                    }
                    __DEFFERER.reverse()
                    __DEFFERER.onload('First')
                    
                    if (this.interval) clearInterval(this.interval)
                    this.interval = setInterval(()=>this._saveStage(), 30000) //Автосохранение

                  })
              , 1000)
          }
          API.projects.getProject(this.$route.params.id).then(onHaveBackground).catch(
            e=>(console.warn('Canvas.vue No background',e),this._showBackgroundPopup(this._loadProjectItems()))
          )
      },


      //===================================================================
      //============================ ПОПАПЫ ===============================
      //===================================================================

      _showBackgroundPopup() {
        this.isPopupBg = true;
      },

      _showImgPopup() {
        this.isPopupImg = true;
      },

      _showVideoPopup() {
        this.isPopupVideo = true;
      },
      
      _showSavedPopup() {

        this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Идет сохранение',
              text: ''
            });
        //this.isPopupSaving = true;
         return ()=>(/*(this.isPopupSaving = false) , */console.log('Saved'));
        
        
      },


      _uploadBackground(img, file) {
        canvasUpload.uploadBackground(img, file, this)
      },

      _uploadImage(img, file) {
        canvasUpload.uploadImage(img, file, this)
      },

      //===================================================================
      //=========================== КОНТРОЛЫ ==============================
      //===================================================================

      _upItem() {
        this.currentObject.moveUp();
        this.transform.zIndex(this.layer.children.length - 1)
        this.layer.draw();
      },

      _downItem() {
        if (this.layer.children[1].attrs.type === 'background' && this.currentObject.zIndex() > 2 ||
          this.layer.children[1].attrs.type !== 'background' && this.currentObject.zIndex() > 1) {
          this.currentObject.moveDown();
          this.transform.zIndex(this.layer.children.length - 1)
          this.layer.draw();
        }
      },

      _destroyItem() {
          let bg_id;
          if (this.currentObject){

            for (const item of this.layer.children) {
                if (item.attrs.type == 'background') {
                    bg_id = item.attrs.bg_id;
                }
            }
            
            let req = {
                bg_id: bg_id,
                name: (this.currentObject.attrs.type == 'text') ? this.currentObject.children[1].attrs.name : this.currentObject.attrs.name, // костыль, но не костыль
                type: this.currentObject.attrs.type
            }
  
            API.projects.deleteItem(req);
  
            this.layers = this.layers.filter(item => item._id !== this.currentObject._id);
            this.currentObject.destroy();
            this.transform.detach();
            this.layer.draw();
            this.currentObject = null;
          }
      },

      _freezeItem() {
        this.currentObject.draggable(!this.currentObject.draggable());
        this._attacheTransform(this.currentObject);
      },

      //===================================================================
      //=========================== ПОМОШНИКИ =============================
      //===================================================================
      _createImage(file) {
        canvasHelper.createImage(file, this)
      },

      _onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        this._createImage(files[0]);
      },

      _clearGrid() {
        canvasHelper.clearGrid(this)
      },

      _selectLayer(layer) {
        this._attacheTransform(layer);
      },

      _attacheTransform(object) {
        canvasHelper.attacheTransform(object, this)
      },

      _alignText(align) {
        this.currentTextAlign = align;
        this.currentObject.children.filter(item => item instanceof Konva.Text)[0].align(align);
        this.layer.draw();
      },

      _typeOfLayer(layer) {
        return canvasHelper.getLayerType(layer);
      },
    }
  };
</script>
<style >
  li.vc-compact-color-item:nth-of-type(n+23),
  .vc-material-split{
    display: none !important;
  }
</style>
<style lang="scss" scoped>
  @import "@assets/scss/constructor/canvas.scss";
</style>
